export default __webpack_public_path__ + "assets/images/email-header.jpg";